export function ApproachPage() {
  return (
    <div className="bg-slate-950 py-24">
      <div className="mx-auto max-w-6xl px-6">
        <header className="max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-emerald-300">
            Approach & Method
          </p>
          <h1 className="mt-4 text-4xl font-semibold text-white">
            A repeatable method that delivers measurable UX and operational outcomes.
          </h1>
          <p className="mt-4 text-slate-300">
            We combine clarity, operational reality, accessibility, and metrics from day one.
          </p>
        </header>
        <div className="mt-16 grid gap-8 md:grid-cols-2">
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white">Principles</h2>
            <ul className="space-y-3 text-sm text-slate-300">
              <li>Clarity over complexity.</li>
              <li>Operational reality beats slideware.</li>
              <li>Accessibility and inclusivity are non-negotiable.</li>
              <li>Metrics defined and measured from day one.</li>
            </ul>
          </section>
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white">Method</h2>
            <ol className="space-y-3 text-sm text-slate-300">
              <li><strong>Discover:</strong> Research, workflow mapping, analytics review.</li>
              <li><strong>Design:</strong> Flows, UI, prototypes, AI use cases.</li>
              <li><strong>Pilot:</strong> Usability, feedback cycles, iteration.</li>
              <li><strong>Launch & Iterate:</strong> Governance, metrics, adoption enablement.</li>
            </ol>
          </section>
        </div>
      </div>
    </div>
  );
}
